/**
 * Bepaalt in welke collectie een notitie hoort die binnen een taak geschreven
 * wordt. Volgorde is bewust: een taak die aan een huishouden of deelnemer hangt
 * hoort daar thuis, ook als er toevallig een ProjectID op staat.
 *
 * @typedef {object} NoteTarget
 * @property {string} collection - Firestore-collectie waar de notitie landt
 * @property {string|null} parentField - Veld dat naar de eigenaar wijst
 * @property {string|null} parentValue - Waarde van dat veld
 *
 * @param {{AdressID?: string, PersonaID?: string, ProjectID?: string}|null|undefined} task
 * @returns {NoteTarget}
 */
const getNoteTarget = (task) => {
    if (task?.AdressID) {
        return { collection: 'AdressNotes', parentField: 'AdressID', parentValue: task.AdressID }
    }
    if (task?.PersonaID) {
        return { collection: 'PersonaReports', parentField: 'PersonaID', parentValue: task.PersonaID }
    }
    // Afspraken die de Deccos-beheertenant bij een klantproject vastlegt.
    // AI-CONTEXT: See docs/features/deccos-projectafspraken.md
    if (task?.ProjectID) {
        return { collection: 'ProjectNotes', parentField: 'ProjectID', parentValue: task.ProjectID }
    }
    return { collection: 'TaskNotes', parentField: null, parentValue: null }
}

export default getNoteTarget
